import {FileConfiguration} from '../../file/message/FileConfiguration';
import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class FileExistsConfiguration extends PredefinedBaseConfiguration {
file: FileConfiguration;
}

